import React from "react";
import cns from "classnames";
import Backdrop from "@material-ui/core/Backdrop";
import Popper from "@material-ui/core/Popper";
import { MenuRendererProps } from "./utils";

type Props = MenuRendererProps & {
  onClose: (e: React.SyntheticEvent<any>) => void;
};

export function DefaultMenuRenderer(props: Props) {
  const {
    focusedOption,
    focusOption,
    inputValue,
    instancePrefix,
    onClose,
    onFocus,
    onOptionRef,
    onSelect,
    optionClassName,
    optionComponent,
    optionRenderer,
    options,
    removeValue,
    renderMenu,
    selectValue,
    valueArray,
    valueKey
  } = props;

  const Option = optionComponent;

  const anchor = document.getElementById(`${instancePrefix}-value`).parentElement
    .parentElement;

  const anchorWidth = anchor.getBoundingClientRect().width;

  let menu = (
    <div className="Select-menu-dropdown" style={{ minWidth: anchorWidth }}>
      {options.map((option, i) => {
        const isSelected =
          valueArray && valueArray.some((x) => x[valueKey] === option[valueKey]);
        const isFocused = focusedOption ? option.value === focusedOption.value : false;
        const optionClass = cns(optionClassName, {
          "Select-option": true,
          "is-selected": isSelected,
          "is-focused": isFocused,
          "is-disabled": option.disabled
        });

        return (
          <Option
            className={optionClass}
            focusOption={focusOption}
            inputValue={inputValue}
            instancePrefix={instancePrefix}
            isDisabled={option.disabled}
            isFocused={isFocused}
            isSelected={isSelected}
            key={`option-${i}-${option[valueKey]}`}
            onFocus={onFocus}
            onSelect={onSelect}
            option={option}
            optionIndex={i}
            ref={(ref) => {
              onOptionRef(ref, isFocused);
            }}
            removeValue={removeValue}
            selectValue={selectValue}
          >
            {optionRenderer(option, i, inputValue)}
          </Option>
        );
      })}
    </div>
  );

  menu = renderMenu ? renderMenu(menu) : menu;

  return (
    <Popper
      open={true}
      id={instancePrefix}
      anchorEl={anchor}
      style={{
        zIndex: 9999
      }}
      placement="bottom-start"
    >
      <Backdrop open invisible onClick={onClose} />
      {menu}
    </Popper>
  );
}
